import { Pipe, PipeTransform } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'mailSendStatus',
  standalone: false,
})
export class MailSendStatusPipe implements PipeTransform {


  constructor(
    private translate: TranslateService
  ) { }

  transform(value: number): any {
    let type: string = '';

    switch (value) {
      case AppConst.MAIL_SEND_STATUS_UNSEND:
        type = this.translate.instant('未送信');
        break;
      case AppConst.MAIL_SEND_STATUS_SENDING:
      type = this.translate.instant('送信中');
      break;
      case AppConst.MAIL_SEND_STATUS_CANCEL_SENDING:
      type = this.translate.instant('送信中（取消）');
      break;
      case AppConst.MAIL_SEND_STATUS_SUCCESS:
        type = this.translate.instant('成功');
        break;
      case AppConst.MAIL_SEND_STATUS_FAILURE:
        type = this.translate.instant('失敗');
        break;
    }
    return type;
  }

}
